var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSupportUser
    ? _c("div", { staticClass: "tile is-parent pl-1" }, [
        _c("section", { staticClass: "tile is-child box" }, [
          _vm._m(0),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-four-fifths" },
              [
                _vm._m(1),
                _vm.defaultStages.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.defaultStages, function (stage, key) {
                        return _c("div", { key: key }, [
                          _c("div", { staticClass: "pb-3" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "box is-shadowless default-stage-box has-border",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "columns is-vcentered is-gapless",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "column is-half is-flex is-align-items-center",
                                      },
                                      [
                                        _vm._m(2, true),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "has-text-weight-bold is-size-6",
                                          },
                                          [_vm._v(_vm._s(stage.jobStageName))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "column is-half is-flex is-justify-content-space-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pl-3 is-size-6" },
                                          [
                                            _vm._v(
                                              _vm._s(stage.subJobStageName)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tag is-small default-stage-tag",
                                          },
                                          [_vm._v(" Default SubJobStage ")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _c(
                  "draggable",
                  {
                    attrs: {
                      list: _vm.customStages,
                      group: "customStages",
                      handle: ".item-drag-handle",
                    },
                    on: { change: () => _vm.updateSortKeys() },
                  },
                  _vm._l(_vm.customStages, function (stage, key) {
                    return _c("div", { key: key }, [
                      _c(
                        "div",
                        { staticClass: "pb-3" },
                        [
                          _c(
                            "ExpendableDiv",
                            {
                              ref: _vm.setExpendableDivRefs,
                              refInFor: true,
                              style: {
                                border:
                                  !stage.jobStage || !stage.subJobStageId
                                    ? "1px solid #D92550"
                                    : "",
                              },
                              attrs: {
                                title: stage.jobStageName,
                                "sub-title": stage.subJobStageName,
                                "expended-title": "Job Stage",
                                "expended-sub-title": "Sub Job Stage",
                                "enable-sort": true,
                              },
                            },
                            [
                              _c("div", { staticClass: "columns" }, [
                                _c("div", { staticClass: "column is-half" }, [
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "select is-fullwidth",
                                        class: { "is-danger": !stage.jobStage },
                                      },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: stage.jobStage,
                                                expression: "stage.jobStage",
                                              },
                                            ],
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    stage,
                                                    "jobStage",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                                function ($event) {
                                                  return _vm.fetchSubJobStages(
                                                    stage
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          _vm._l(
                                            _vm.jobStages,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.stage,
                                                  attrs: {
                                                    disabled:
                                                      !_vm.hasAvailableSubJobStages(
                                                        item.stage,
                                                        stage
                                                      ),
                                                  },
                                                  domProps: {
                                                    value: item.stage,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.description) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        !stage.jobStage
                                          ? _c(
                                              "span",
                                              { staticClass: "help is-danger" },
                                              [_vm._v("Field is required.")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "column is-half" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "control is-flex is-align-items-end is-flex-direction-column",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "select is-fullwidth",
                                          class: {
                                            "is-danger": !stage.subJobStageId,
                                          },
                                        },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: stage.subJobStageId,
                                                  expression:
                                                    "stage.subJobStageId",
                                                },
                                              ],
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    stage,
                                                    "subJobStageId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              stage.subJobStageOptions,
                                              function (item) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: item.subJobStageId,
                                                    domProps: {
                                                      value: item.subJobStageId,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.subJobStageName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            "is-flex is-justify-content-space-between is-align-items-center":
                                              !stage.subJobStageId,
                                          },
                                          style: {
                                            width: !stage.subJobStageId
                                              ? "100%"
                                              : "",
                                          },
                                        },
                                        [
                                          !stage.subJobStageId
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "help is-danger",
                                                },
                                                [_vm._v("Field is required.")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "icon has-text-danger",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeStage(key)
                                                },
                                                mousedown: function ($event) {
                                                  _vm.deletingStageKey = key
                                                },
                                                mouseup: function ($event) {
                                                  _vm.deletingStageKey = null
                                                },
                                                mouseleave: function ($event) {
                                                  _vm.deletingStageKey = null
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "mso mso-20px",
                                                  class: {
                                                    "mso-fill":
                                                      _vm.deletingStageKey ===
                                                      key,
                                                  },
                                                },
                                                [_vm._v(" Delete")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass: "button is-primary is-inverted is-fullwidth",
                    staticStyle: {
                      border: "1px solid #e7e8eb",
                      "border-radius": "6px",
                    },
                    on: { click: _vm.addStage },
                  },
                  [_vm._m(3), _vm._v(" Add New ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "column is-one-fifths" }, [
              _c("h3", { staticClass: "subtitle" }, [
                _vm._v("Available Sub Stages"),
              ]),
              _vm.entitySummaries.length === 0
                ? _c(
                    "div",
                    {
                      staticClass: "p-4 mb-2",
                      class: `has-background-${_vm.$theme.name}`,
                      staticStyle: { "font-size": "0.9em" },
                    },
                    [_vm._m(4)]
                  )
                : _c(
                    "ul",
                    _vm._l(
                      _vm.groupedStages,
                      function (subStages, jobStageName) {
                        return _c(
                          "li",
                          {
                            key: jobStageName,
                            staticClass: "is-flex",
                            class: `has-background-${_vm.$theme.name}`,
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass: "job-stage has-text-weight-bold",
                                },
                                [_vm._v(" " + _vm._s(jobStageName) + " ")]
                              ),
                              _c(
                                "ul",
                                { staticClass: "pl-5" },
                                _vm._l(subStages, function (name) {
                                  return _c("li", { key: name }, [
                                    _vm._v("- " + _vm._s(name)),
                                  ])
                                }),
                                0
                              ),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
            ]),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
        _c(
          "div",
          {
            staticClass:
              "notification is-danger is-flex is-justify-content-center is-size-4",
            staticStyle: { width: "50%" },
          },
          [_vm._v("You do not have permissions on this page")]
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "subtitle mb-5" }, [_vm._v("Sub Stages Setup")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-half" }, [
        _c("span", { staticClass: "subtitle" }, [_vm._v("Job Stage")]),
      ]),
      _c("div", { staticClass: "column is-half" }, [
        _c("span", { staticClass: "subtitle" }, [_vm._v("Sub Job Stage")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon has-text-grey mr-1 default-stage-icon" },
      [_c("span", { staticClass: "mso mso-14px" }, [_vm._v("lock")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon mr-1" }, [
      _c("span", { staticClass: "mso mso-20px" }, [_vm._v("Add")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-flex is-align-items-center" }, [
      _c("div", [
        _c("p", [_vm._v("No Available Sub Stages.")]),
        _c("p", [_vm._v("Click Add New to Set Up.")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }